import React from "react";
import { motion } from "framer-motion";
import { FaMapMarkerAlt, FaInstagram } from "react-icons/fa";

const Contact: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-black to-gray-900">
      <div className="absolute inset-0 bg-[url('/noise.png')] opacity-5 pointer-events-none"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6 tracking-wide">
            İletişim
          </h2>
          <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto">
            Bizimle iletişime geçmek için aşağıdaki formu doldurabilirsiniz
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1 space-y-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-300"
            >
              <div className="flex items-center space-x-4 mb-4">
                <div className="bg-blue-600/20 p-3 rounded-lg">
                  <FaMapMarkerAlt className="text-blue-400 text-2xl" />
                </div>
                <h3 className="text-xl font-semibold text-white">Adres</h3>
              </div>
              <p className="text-gray-400">
                Esentepe Mah. Büyükdere Cad. Ecza Sok. Pol Center, C Blok No:
                C16, Levent Şişli/İstanbul
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-300"
            >
              <div className="flex items-center space-x-4 mb-4">
                <div className="bg-pink-600/20 p-3 rounded-lg">
                  <FaInstagram className="text-pink-400 text-2xl" />
                </div>
                <h3 className="text-xl font-semibold text-white">Instagram</h3>
              </div>
              <a
                href="https://instagram.com/kolektifolusum"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-pink-400 transition-colors text-lg"
              >
                @kolektifolusum
              </a>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lg:col-span-2 rounded-2xl overflow-hidden bg-white/5 backdrop-blur-sm border border-white/10 shadow-2xl"
          >
            <div className="p-2">
              <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLSdB9akJCJeXzR9w4Trui6KKtNc3w0kE2P2gowSz9dRoBtfSVA/viewform?embedded=true"
                className="w-full h-[800px] md:h-[700px]"
                loading="lazy"
              >
                Yükleniyor...
              </iframe>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
